import {DescService} from "@bufbuild/protobuf";
import { createConnectTransport } from "@connectrpc/connect-web";
import { createClient,Client} from "@connectrpc/connect";
import { Interceptor } from "@connectrpc/connect";
import { useMemo } from "react";
import { tokenKey } from "./constant";
import { toast } from "react-toastify";

const authInjector: Interceptor = (next) => async (req) => {
    const token = localStorage.getItem(tokenKey);
    req.header.set("X-MyTest-Client", `mytest-client`);
    if (token) {
        req.header.set("Authorization", `Bearer ${token}`);
    }

    try {
        return await next(req);
    } catch (error: any) {
        if (error?.code === 16) {
            toast.dismiss();
            toast.error("Token expired. Please log in again.");
            localStorage.removeItem(tokenKey);
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);
        }
        throw error;
    }
};

const baseUrl = process.env.REACT_APP_API_BASE_URL || '/';
const transport = createConnectTransport({
    // FIXME: we need to use production URL here for local debug, server sdie push relies on http/2.0, create-react-app proxy only supports http/1.1
    // baseUrl: "https://mdb-ng-production-admin-grpc.vendingontrack.com/",
    baseUrl: baseUrl,
    interceptors: [authInjector]
});


/**
 * Get a promise client for the given service.
 */
export function useClient<T extends DescService>(service: T): Client<T> {
    // We memoize the client, so that we only create one instance per service.
    return useMemo(() => createClient(service, transport), [service]);
}